$(function(){
  // js-close-nomore
  $(document).on('click', '.js-close-nomore', function(){
    $(".nomore__box").remove();
  });

  // console.log('ok');
});



// WEBPACK FOOTER //
// ./_src/js/action/nomore.js